import React from 'react'

export type SvgImageProps = React.ImgHTMLAttributes<HTMLImageElement>

const SvgImage: React.FC<SvgImageProps> = (props) => (
  <img alt={props.alt} {...props} />
)

export default SvgImage
